export enum PasswordResetDialogCloseReason {
  USER_CLOSE,
  LOGIN,
}
